import { marksCtx } from './schema';
export const markFactory = (mark) => () => (ctx) => {
    const atom = typeof mark === 'function' ? mark(ctx) : mark;
    ctx.update(marksCtx, (prev) => prev.concat(atom));
};
//# sourceMappingURL=mark-factory.js.map